// This utility function is designed to handle lazy loading of React components with a retry
// mechanism in case of chunk load errors. It checks if the component import fails due to a
// chunk load error and attempts to reload the page once before giving up.

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type LazyModule = { default: React.ComponentType<any> }

const isChunkLoadError = (error: unknown): boolean => {
  return error instanceof Error && (error.name === 'ChunkLoadError' || /loading.*chunk.*failed/i.test(error.message))
}

export const lazyRetry = function (componentImport: () => Promise<LazyModule>): Promise<LazyModule> {
  return new Promise((resolve, reject) => {
    const hasRefreshed = window.sessionStorage.getItem('retry-lazy-refreshed') === 'true'

    componentImport()
      .then((component) => {
        resolve(component)
      })
      .catch((error) => {
        if (!hasRefreshed && isChunkLoadError(error)) {
          window.sessionStorage.setItem('retry-lazy-refreshed', 'true')
          return window.location.reload()
        }
        reject(error)
      })
  })
}
